import "bootstrap/dist/css/bootstrap.min.css";
import BarGraph from "components/graphs/BarGraph";
import React from "react";
import { Card, Col, Row } from "react-bootstrap";

const GNSSPositioningAccuracyCard = ({ innerRef, data }) => {
  const renderGraphs = (constellations) => {
    return constellations.map((constellation, index) => (
      <React.Fragment key={index}>
        {constellation.bands.map((band, index) => {
          const height = band.plots.length === 1 ? 400 : 200;
          return (
            <React.Fragment key={index}>
              <p className="text-justify">
                Positioning accuracy for {constellation.name} {band.name} (ICAO
                threshold: {band.plots[0].thresholdValues[0]} m for HPE and{" "}
                {band.plots[1].thresholdValues[0]} m for VPE)
              </p>
              <Col xxl={{ span: 10, offset: 1 }}>
                <Row>
                  {band.plots.map((plot, index) => (
                    <Col
                      key={index}
                      sm={{ span: 12, offset: 0 }}
                      md={{ span: 5, offset: 0 }}
                      lg={{ span: 5, offset: 0 }}
                      xl={{ span: 5, offset: 0 }}
                    >
                      <BarGraph width={400} height={height} dataset={plot} />
                    </Col>
                  ))}
                </Row>
              </Col>
            </React.Fragment>
          );
        })}
      </React.Fragment>
    ));
  };

  return (
    <>
      <Card.Title as="h6" ref={innerRef}>
        Positioning accuracy
      </Card.Title>
      <Card.Body>
        <p className="text-justify">
          The positioning accuracy represents the 95th percentile of the
          position error measured, intended as the difference between the
          estimated position by the receiver and the reference position,
          calculated over a 24-hours interval.
        </p>
        {renderGraphs(data.constellations)}
      </Card.Body>
    </>
  );
};

export default React.memo(
  React.forwardRef((props, ref) => (
    <GNSSPositioningAccuracyCard innerRef={ref} {...props} />
  ))
);
